const theme = {
  color: {
    primary: "#14deb5",
    primary_bright: "#40EDC9",
    secondary: "#ae19d4",
  },
};

export default theme;
